import { render, staticRenderFns } from "./_password.vue?vue&type=template&id=2d8aeb04&scoped=true"
import script from "./_password.vue?vue&type=script&lang=js"
export * from "./_password.vue?vue&type=script&lang=js"
import style0 from "./_password.vue?vue&type=style&index=0&id=2d8aeb04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8aeb04",
  null
  
)

export default component.exports